/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React, { useContext } from 'react';
import { FlowBlock } from '@staffino/model';
import {
  DividerBlock,
  ImageBlock,
  VideoBlock,
  BlockWrapper,
  ColorTheme,
} from '@staffino/flow-controls';
import FlowContext from '../flow-context';
import PageBlock from './page-block';
import TerminalPageBlock from './terminal-page-block';
import QuestionBlock from './question-block';
import ProfileBlock from './profile-block';
import PageBreakBlock from './page-break-block';
import TargetGridBlock from './target-grid-block';
import HeadlineBlock from './headline-block';
import ParagraphBlock from './paragraph-block';
import LegalBlock from './legal-block';
import LinkBlock from './link-block';
import RowBlock from './row-block';
import NavigationBarBlock from './navigation-bar-block';
import TosBlock from './tos-block';
import ContainerBlock from './container-block';
import ButtonBlock from './button-block';
import FlowRestartBlock from './flow-restart-block';
import InputBlock from './input-block';
import WarningBlock from './warning-block';
import CustomerContactBlock from './customer-contact-block';
import QRBlock from './qr-block';

const blockMap = {
  container: ContainerBlock,
  page: PageBlock,
  'terminal-page': TerminalPageBlock,
  'warning-page': PageBlock,
  warning: WarningBlock,
  paragraph: ParagraphBlock,
  headline: HeadlineBlock,
  link: LinkBlock,
  row: RowBlock,
  divider: DividerBlock,
  question: QuestionBlock,
  break: PageBreakBlock,
  button: ButtonBlock,
  image: ImageBlock,
  video: VideoBlock,
  profile: ProfileBlock,
  input: InputBlock,
  legal: LegalBlock,
  'target-grid': TargetGridBlock,
  'navigation-bar': NavigationBarBlock,
  tos: TosBlock,
  'flow-restart': FlowRestartBlock,
  'customer-contact': CustomerContactBlock,
  qr: QRBlock,
};

type Props = {
  block: FlowBlock;
};

export default function BlockFactory({ block }: Props) {
  const { stateManager } = useContext(FlowContext);
  const Factory = blockMap[block.type];
  const overriddenBlock = stateManager.getOverriddenBlock(block);
  const { margin, padding, background, hidden, themeColors } = overriddenBlock;
  if (hidden) {
    return null;
  }
  if (Factory) {
    return (
      <ColorTheme colors={themeColors}>
        <BlockWrapper
          margin={margin}
          padding={
            'fullWidth' in block && block.fullWidth ? 'inherit' : padding
          }
          background={background}
        >
          <Factory block={overriddenBlock} />
        </BlockWrapper>
      </ColorTheme>
    );
  }
  return null;
}
